import type { ReactNode } from 'react'
import { Button, Dropdown, type MenuProps } from 'antd'
import { MoreOutlined } from '@ant-design/icons'

export interface RowAction {
  key: string
  label: string
  icon?: ReactNode
  /** Qizil — qaytarib bo'lmaydigan yoki xizmatni to'xtatadigan amal */
  danger?: boolean
  /**
   * Ko'rinadi, lekin bosilmaydi. ⚠️ `hidden` DAN FARQI MA'NOLI:
   * `disabled` — «hozir mumkin emas» (masalan yopilgan abonentni
   * bloklash), `hidden` — «sizga umuman ochilmagan». Ikkalasini
   * aralashtirish foydalanuvchiga «ilova buzuq» degan taassurot
   * berardi — amal bor edi, keyin yo'qoldi.
   */
  disabled?: boolean
  hidden?: boolean
  onClick: () => void
}

interface RowActionsProps {
  actions: readonly RowAction[]
  /** Ekran o'quvchisi uchun: «Amallar» yolg'iz uch nuqtadan ma'no chiqmaydi */
  ariaLabel: string
}

/**
 * Qator amallari — UCH NUQTA menyusi.
 *
 * <h2>⚠️ NEGA ADMIN PANELIDAGI `shared/ui/table/RowActions` KO'CHIRILMADI</h2>
 * U `DataTable` bilan birga yashaydi va uning holatiga (tanlangan
 * qatorlar, ommaviy amal, ustun sozlamalari) bog'langan. `DataTable`
 * ning o'zi ~900 qator va u bu ilovaga ATAYLAB olib kelinmagan
 * (11-SHERIK-KABINETI-UI.md §1). Bog'liqligini yechib ko'chirish —
 * o'sha faylni qaytadan yozish bilan teng. Bu yerda kerak bo'lgani
 * bitta: ro'yxat va tugma.
 *
 * <h2>⚠️ NEGA UMUMAN MENYU (egasi talabi, 2026-08-17)</h2>
 * Qatorga to'rt-besh tugma qo'yilsa, ular jadvalning eng o'ng ustunini
 * ikkiga bo'ladi va telefonda umuman sig'maydi. Uch nuqta esa bitta
 * barmoq nishoni bo'lib qoladi va amal nomlari MATN bilan chiqadi —
 * ikonkalarni taxmin qilish kerak bo'lmaydi.
 *
 * ⚠️ Amal qolmasa tugma UMUMAN chizilmaydi: bo'sh menyu ochadigan
 * tugma «bosdim, hech narsa bo'lmadi» degan nosozlikka o'xshaydi.
 */
export function RowActions({ actions, ariaLabel }: RowActionsProps) {
  const visible = actions.filter((action) => action.hidden !== true)
  if (visible.length === 0) return null

  const items: MenuProps['items'] = visible.map((action) => ({
    key: action.key,
    label: action.label,
    icon: action.icon,
    danger: action.danger ?? false,
    disabled: action.disabled ?? false,
  }))

  const onClick: MenuProps['onClick'] = ({ key }) => {
    visible.find((action) => action.key === key)?.onClick()
  }

  return (
    <Dropdown menu={{ items, onClick }} trigger={['click']} placement="bottomRight">
      <Button
        type="text"
        icon={<MoreOutlined />}
        aria-label={ariaLabel}
        // ⚠️ 40px — barmoq nishoni (11-SHERIK-KABINETI-UI.md §8: min 44,
        // jadval qatorida `controlHeight` bilan bir xil balandlik).
        style={{ width: 40, height: 40 }}
        onClick={(e) => e.stopPropagation()}
      />
    </Dropdown>
  )
}
